<template>
  <div>
    <logged-in-header />
    <dashboard />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import dashboard from "../components/dashboard/Dashboard";

export default {
  components: {
    loggedInHeader,
    dashboard
  }
};
</script>
